import { useState } from "react";

const useLocalStorage = (key, initialValue) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            if (!item || item === "undefined") {
                return initialValue;
            }
            return JSON.parse(item);
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const setValue = (value) => {
        try {
            // ✅ support functional updates
            setStoredValue(prev => {
                const valueToStore =
                    value instanceof Function ? value(prev) : value;
                if (valueToStore === undefined) {
                    localStorage.removeItem(key);
                } else {
                    localStorage.setItem(key, JSON.stringify(valueToStore));
                }
                return valueToStore;
            });
        } catch (error) {
            console.log(error);
        }
    };
    return [storedValue, setValue];
};

export default useLocalStorage;